export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/channel-social.f3e17d79-2b1ef6.svg";